import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=460bbc58&scoped=true&"
import script from "./Prize.vue?vue&type=script&lang=js&"
export * from "./Prize.vue?vue&type=script&lang=js&"
import style0 from "./Prize.vue?vue&type=style&index=0&id=460bbc58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bbc58",
  null
  
)

export default component.exports